import { Container, Flex } from '@chakra-ui/react';

import { Copyright, SocialMediaLinks } from '@components/Footer';

import { ContainerMaxW } from '../../layouts/EventLayout';

const FooterSection = () => {
  return (
    <Flex w="full">
      <Container maxW={ContainerMaxW}>
        <Flex
          flexDirection="row"
          justifyContent="space-between"
          py={{ base: '20px', md: '40px' }}
          alignItems="center"
        >
          <Copyright />
          <SocialMediaLinks />
        </Flex>
      </Container>
    </Flex>
  );
};

export default FooterSection;
